import { render, staticRenderFns } from "./AddResource.vue?vue&type=template&id=6f5da434&"
import script from "./AddResource.vue?vue&type=script&lang=js&"
export * from "./AddResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports